/*global window, jQuery, calendar */
(function($) {

  'use strict';

  $(function() {

  	var element = document.querySelector('.shuffle-container');
		
		var shuffleInstance = new Shuffle(element, {
			filterMode: Shuffle.FilterMode.ALL,
		  itemSelector: '.prodotto',
		  sizer: null
		});
		
		shuffleInstance.filter(Shuffle.ALL_ITEMS);
		
  	$('#filtraCollezione').on('change', function(){
  		applyFilters();
  	});

  	$('#filtraTipologia').on('change', function(){
  		applyFilters();
  	});

  	var applyFilters = function() {
  		var f1 = $('#filtraCollezione').val();
  		var f2 = $('#filtraTipologia').val();
  		if (f1 == '') f1 = 'all';
  		if (f2 == '') f2 = 'all';
  		
  		if (f1 == 'all' && f2 == 'all') {
  			shuffleInstance.filter(Shuffle.ALL_ITEMS);
  		}
  		if (f1 == 'all' && f2 != 'all') {
  			shuffleInstance.filter(f2);
  		}
  		if (f2 == 'all' && f1 != 'all') {
  			shuffleInstance.filter(f1);
  		}
  		if (f1 != 'all' && f2 != 'all') {
  			shuffleInstance.filter([f1,f2]);
  		}
  	}

  	
  });

  



}(jQuery));